export interface Creator {
  id: string;
  userId: string;
  bio: string | null;
  followersCount: number;
  links: string | null;
  branding: string | null;
  createdAt: Date;
  updatedAt: Date;
}
